import { Text } from "react-native"
import translations from '../utils/translations.json';

type TranslateTextProps = {
    children?: any,
    style?: any
}

export const TranslateText = ({children, style}: TranslateTextProps) => {
    return (
        <Text style={style}>{translations[children] || children}</Text>
    )
}